export default __webpack_public_path__ + "static/media/resume_ready.278f4575.png";